import { Avatar, Grid, ListItemAvatar, ListItemText } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import {
  WsColors,
  WsTypoColors,
  WsTypography,
  WsTypoVariants,
  JobsIconAlt,
  CandidateIconAlt,
} from 'wisestep-base';

import { AnalyticsMenuItem } from '../../analyticsPage/components/AnalyticsContentLayout';

const JobsAndSkillsMatrix = () => {
  const navigate = useNavigate();
  return (
    <Grid container spacing={2} ml={1}>
      <Grid item xs={6}>
        <AnalyticsMenuItem
          sx={{ bgcolor: WsColors.White }}
          onClick={() => navigate('job-demand-matrix')}
        >
          <ListItemAvatar>
            <Avatar>
              <JobsIconAlt />
            </Avatar>
          </ListItemAvatar>
          <ListItemText
            primaryTypographyProps={{ fontWeight: 700 }}
            primary="Job Demand Matrix"
            secondary={
              <WsTypography variant={WsTypoVariants.BODY2} color={WsTypoColors.BLACK}>
                Most Demanding Job Skills
              </WsTypography>
            }
          />
        </AnalyticsMenuItem>
      </Grid>
      <Grid item xs={6}>
        <AnalyticsMenuItem
          sx={{ bgcolor: WsColors.White }}
          onClick={() => navigate('talent-matrix')}
        >
          <ListItemAvatar>
            <Avatar>
              <CandidateIconAlt />
            </Avatar>
          </ListItemAvatar>
          <ListItemText
            primaryTypographyProps={{ fontWeight: 700 }}
            primary="Talent Matrix"
            secondary={
              <WsTypography variant={WsTypoVariants.BODY2} color={WsTypoColors.BLACK}>
                Candidate Talent Skills
              </WsTypography>
            }
          />
        </AnalyticsMenuItem>
      </Grid>
    </Grid>
  );
};

export default JobsAndSkillsMatrix;
